"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.socialService = void 0;
const firebaseBase_1 = require("./firebaseBase");
const unifiedFirestoreService_1 = require("./unifiedFirestoreService");
const FOLLOWING_CHUNK_SIZE = 10; // Firestore 'in' operator limit
/** Firestore rejects `undefined` in document data (e.g. optional metadata fields). */
function omitUndefinedDeep(input) {
    if (input === undefined || input === null) {
        return input;
    }
    if (typeof input !== 'object') {
        return input;
    }
    if (Array.isArray(input)) {
        return input.map((item) => omitUndefinedDeep(item));
    }
    const out = {};
    for (const [key, val] of Object.entries(input)) {
        if (val === undefined) {
            continue;
        }
        out[key] = omitUndefinedDeep(val);
    }
    return out;
}
/**
 * Social Service (Cross-Platform)
 * Handles following, notifications, and social features
 */
class SocialService {
    // =============== FOLLOWING SYSTEM ===============
    /**
     * Follow a user
     */
    followUser(followerUid, followingUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                console.log('🔥 SocialService: followUser called:', { followerUid, followingUid });
                // Don't allow self-following
                if (followerUid === followingUid) {
                    throw new Error('Users cannot follow themselves');
                }
                // Check if already following to prevent duplicate relationships
                const docId = `${followerUid}_${followingUid}`;
                console.log('🔥 SocialService: Checking existing follow relationship:', docId);
                const existingRelation = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userFollowing', docId);
                if (existingRelation.exists()) {
                    console.log(`SocialService: User ${followerUid} is already following ${followingUid}`);
                    return; // Don't create duplicate relationship or increment counters
                }
                // Create following relationship
                console.log('🔥 SocialService: Creating follow relationship document');
                yield (0, unifiedFirestoreService_1.unifiedSetDoc)('userFollowing', docId, {
                    followerUid,
                    followingUid,
                    createdAt: new Date().toISOString(),
                });
                console.log('🔥 SocialService: Follow relationship created successfully');
                // Update follower's following count (manual increment for platform compatibility)
                console.log('🔥 SocialService: Updating follower following count for:', followerUid);
                const followerDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', followerUid);
                if (followerDoc.exists()) {
                    const followerData = followerDoc.data();
                    const currentFollowingCount = ((_a = followerData.stats) === null || _a === void 0 ? void 0 : _a.followingCount) || 0;
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userProfiles', followerUid, {
                        'stats.followingCount': currentFollowingCount + 1,
                        updatedAt: new Date().toISOString()
                    });
                }
                console.log('🔥 SocialService: Follower following count updated successfully');
                // Update following user's followers count (manual increment for platform compatibility)
                console.log('🔥 SocialService: Updating followed user followers count for:', followingUid);
                const followedDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', followingUid);
                if (followedDoc.exists()) {
                    const followedData = followedDoc.data();
                    const currentFollowersCount = ((_b = followedData.stats) === null || _b === void 0 ? void 0 : _b.followersCount) || 0;
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userProfiles', followingUid, {
                        'stats.followersCount': currentFollowersCount + 1,
                        updatedAt: new Date().toISOString()
                    });
                }
                console.log('🔥 SocialService: Followed user followers count updated successfully');
                // Create user activity for following user
                console.log('🎯 SocialService: About to create user followed activity for:', { followerUid, followingUid });
                try {
                    const { dataService } = yield Promise.resolve().then(() => __importStar(require('./dataService')));
                    const { authService } = yield Promise.resolve().then(() => __importStar(require('./authService')));
                    const [followerProfile, followedProfile] = yield Promise.all([
                        authService.getUserProfile(followerUid),
                        authService.getUserProfile(followingUid)
                    ]);
                    if (followerProfile) {
                        yield dataService.createUserActivity(followerProfile, 'user_followed', {
                            followedUserId: followingUid,
                            followedUserName: (followedProfile === null || followedProfile === void 0 ? void 0 : followedProfile.displayName) || (followedProfile === null || followedProfile === void 0 ? void 0 : followedProfile.username) || 'Unknown User'
                        });
                        console.log('✅ SocialService: Successfully created user followed activity');
                    }
                }
                catch (activityError) {
                    console.error('❌ SocialService: Failed to create user followed activity:', activityError);
                }
                console.log(`🔥 SocialService: User ${followerUid} is now following ${followingUid}`);
            }), 'followUser');
        });
    }
    /**
     * Unfollow a user
     */
    unfollowUser(followerUid, followingUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                console.log('🔥 SocialService: unfollowUser called:', { followerUid, followingUid });
                const docId = `${followerUid}_${followingUid}`;
                // Check if relationship exists before deleting
                console.log('🔥 SocialService: Checking if follow relationship exists:', docId);
                const existingRelation = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userFollowing', docId);
                if (!existingRelation.exists()) {
                    console.log(`SocialService: User ${followerUid} is not following ${followingUid}, no action needed`);
                    return; // Don't decrement counters if relationship doesn't exist
                }
                console.log('🔥 SocialService: Deleting follow relationship document');
                yield (0, unifiedFirestoreService_1.unifiedDeleteDoc)('userFollowing', docId);
                console.log('🔥 SocialService: Follow relationship deleted successfully');
                // Update both users' stats with manual decrement (platform compatible)
                console.log('🔥 SocialService: Updating user stats after unfollow');
                // Get current counts and decrement manually
                const [followerDoc, followedDoc] = yield Promise.all([
                    (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', followerUid),
                    (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', followingUid)
                ]);
                if (followerDoc.exists()) {
                    const followerData = followerDoc.data();
                    const currentFollowingCount = Math.max(0, (((_a = followerData.stats) === null || _a === void 0 ? void 0 : _a.followingCount) || 0) - 1);
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userProfiles', followerUid, {
                        'stats.followingCount': currentFollowingCount,
                        updatedAt: new Date().toISOString()
                    });
                }
                if (followedDoc.exists()) {
                    const followedData = followedDoc.data();
                    const currentFollowersCount = Math.max(0, (((_b = followedData.stats) === null || _b === void 0 ? void 0 : _b.followersCount) || 0) - 1);
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userProfiles', followingUid, {
                        'stats.followersCount': currentFollowersCount,
                        updatedAt: new Date().toISOString()
                    });
                }
                console.log('🔥 SocialService: User stats updated successfully after unfollow');
            }), 'unfollowUser');
        });
    }
    /**
     * Check if user is following another user
     */
    isFollowing(followerUid, followingUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const docId = `${followerUid}_${followingUid}`;
                const followingSnap = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userFollowing', docId);
                return followingSnap.exists();
            }), 'isFollowing');
        });
    }
    /**
     * Get followers list
     */
    getFollowers(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userFollowing')
                    .where('followingUid', '==', uid)
                    .getDocs();
                return querySnapshot.map(doc => doc.data().followerUid);
            }), 'getFollowers');
        });
    }
    /**
     * Get following list
     */
    getFollowing(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userFollowing')
                    .where('followerUid', '==', uid)
                    .getDocs();
                return querySnapshot.map(doc => doc.data().followingUid);
            }), 'getFollowing');
        });
    }
    /**
     * Get followers list with privacy filtering
     */
    getFollowersForProfile(targetUserId, viewerUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // For now, return basic followers list
                // Privacy filtering can be enhanced based on user preferences
                return this.getFollowers(targetUserId);
            }), 'getFollowersForProfile');
        });
    }
    /**
     * Get following list with privacy filtering
     */
    getFollowingForProfile(targetUserId, viewerUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // For now, return basic following list
                // Privacy filtering can be enhanced based on user preferences
                return this.getFollowing(targetUserId);
            }), 'getFollowingForProfile');
        });
    }
    /**
     * Remove a follower from your own followers list.
     * Deletes the userFollowing doc and decrements counts on both sides.
     * The current user is the followingUid (the one being followed).
     */
    removeFollower(followerUid, currentUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const docId = `${followerUid}_${currentUid}`;
                const existing = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userFollowing', docId);
                if (!existing.exists())
                    return;
                yield (0, unifiedFirestoreService_1.unifiedDeleteDoc)('userFollowing', docId);
                // Decrement follower's followingCount
                const followerDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', followerUid);
                if (followerDoc.exists()) {
                    const d = followerDoc.data();
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userProfiles', followerUid, {
                        'stats.followingCount': Math.max(0, (((_a = d.stats) === null || _a === void 0 ? void 0 : _a.followingCount) || 0) - 1),
                        updatedAt: new Date().toISOString(),
                    });
                }
                // Decrement current user's followersCount
                const currentDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', currentUid);
                if (currentDoc.exists()) {
                    const d = currentDoc.data();
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userProfiles', currentUid, {
                        'stats.followersCount': Math.max(0, (((_b = d.stats) === null || _b === void 0 ? void 0 : _b.followersCount) || 0) - 1),
                        updatedAt: new Date().toISOString(),
                    });
                }
                console.log(`SocialService: Removed follower ${followerUid} from ${currentUid}`);
            }), 'removeFollower');
        });
    }
    // =============== FOLLOW REQUEST SYSTEM ===============
    /**
     * Send a follow request to a private profile.
     * Creates a doc in userFollowRequests/{requesterUid}_{targetUid}.
     */
    sendFollowRequest(requesterUid, targetUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                if (requesterUid === targetUid)
                    throw new Error('Cannot follow yourself');
                const docId = `${requesterUid}_${targetUid}`;
                const existing = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userFollowRequests', docId);
                if (existing.exists())
                    return; // already requested
                yield (0, unifiedFirestoreService_1.unifiedSetDoc)('userFollowRequests', docId, {
                    requesterUid,
                    targetUid,
                    createdAt: new Date().toISOString(),
                });
                console.log(`SocialService: Follow request sent ${requesterUid} → ${targetUid}`);
            }), 'sendFollowRequest');
        });
    }
    /**
     * Cancel a pending follow request (called by the requester).
     */
    cancelFollowRequest(requesterUid, targetUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const docId = `${requesterUid}_${targetUid}`;
                yield (0, unifiedFirestoreService_1.unifiedDeleteDoc)('userFollowRequests', docId);
                console.log(`SocialService: Follow request cancelled ${requesterUid} → ${targetUid}`);
            }), 'cancelFollowRequest');
        });
    }
    /**
     * Check if a pending follow request exists.
     */
    hasFollowRequest(requesterUid, targetUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const docId = `${requesterUid}_${targetUid}`;
                const snap = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userFollowRequests', docId);
                return snap.exists();
            }), 'hasFollowRequest');
        });
    }
    /**
     * Get all pending incoming follow requests for a user (for notification UI).
     */
    getPendingFollowRequests(targetUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const docs = yield (0, unifiedFirestoreService_1.unifiedCollection)('userFollowRequests')
                    .where('targetUid', '==', targetUid)
                    .getDocs();
                return docs.map(d => d.data());
            }), 'getPendingFollowRequests');
        });
    }
    /**
     * Accept a follow request: delete the request doc only.
     * The caller (NotificationsPage / UserFollowContext) is responsible for then
     * calling the followUser Cloud Function so the relationship + stat updates
     * run as the requester's identity (admin SDK path avoids permission issues).
     */
    acceptFollowRequest(requesterUid, targetUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const requestDocId = `${requesterUid}_${targetUid}`;
                yield (0, unifiedFirestoreService_1.unifiedDeleteDoc)('userFollowRequests', requestDocId);
                console.log(`SocialService: Follow request doc deleted ${requesterUid} → ${targetUid}`);
            }), 'acceptFollowRequest');
        });
    }
    /**
     * Decline a follow request: simply delete the request doc.
     */
    declineFollowRequest(requesterUid, targetUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const requestDocId = `${requesterUid}_${targetUid}`;
                yield (0, unifiedFirestoreService_1.unifiedDeleteDoc)('userFollowRequests', requestDocId);
                console.log(`SocialService: Follow request declined ${requesterUid} → ${targetUid}`);
            }), 'declineFollowRequest');
        });
    }
    // =============== WATCHLIST LIKING SYSTEM ===============
    /**
     * Like a watchlist
     */
    likeWatchlist(userUid, watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const docId = `${userUid}_${watchlistId}`;
                // Check if already liked
                const existingLike = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlistLikes', docId);
                if (existingLike.exists()) {
                    console.log('SocialService: Watchlist already liked by user');
                    return;
                }
                // Create like document
                yield (0, unifiedFirestoreService_1.unifiedSetDoc)('watchlistLikes', docId, {
                    userUid,
                    watchlistId,
                    createdAt: new Date().toISOString(),
                });
                // Update watchlist like count (manual increment for platform compatibility)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (watchlistDoc.exists()) {
                    const watchlistData = watchlistDoc.data();
                    const currentCount = watchlistData.followerCount || 0;
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, {
                        followerCount: currentCount + 1,
                        updatedAt: new Date().toISOString(),
                    });
                }
                console.log('SocialService: Watchlist liked successfully');
            }), 'likeWatchlist');
        });
    }
    /**
     * Unlike a watchlist
     */
    unlikeWatchlist(userUid, watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const docId = `${userUid}_${watchlistId}`;
                // Check if like exists
                const existingLike = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlistLikes', docId);
                if (!existingLike.exists()) {
                    console.log('SocialService: Watchlist not liked by user, no action needed');
                    return;
                }
                // Delete like document
                yield (0, unifiedFirestoreService_1.unifiedDeleteDoc)('watchlistLikes', docId);
                // Update watchlist like count (manual decrement for platform compatibility)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (watchlistDoc.exists()) {
                    const watchlistData = watchlistDoc.data();
                    const currentCount = Math.max(0, (watchlistData.followerCount || 0) - 1);
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, {
                        followerCount: currentCount,
                        updatedAt: new Date().toISOString(),
                    });
                }
                console.log('SocialService: Watchlist unliked successfully');
            }), 'unlikeWatchlist');
        });
    }
    /**
     * Check if user is liking a watchlist
     */
    isLikingWatchlist(userUid, watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const docId = `${userUid}_${watchlistId}`;
                const likeSnap = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlistLikes', docId);
                return likeSnap.exists();
            }), 'isLikingWatchlist');
        });
    }
    /**
     * Get watchlist like count
     */
    getWatchlistLikeCount(watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('watchlistLikes')
                    .where('watchlistId', '==', watchlistId)
                    .getDocs();
                return querySnapshot.length;
            }), 'getWatchlistLikeCount');
        });
    }
    /**
     * Get user's liked watchlists
     */
    getLikedWatchlists(userUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                console.log('🔍 SocialService.getLikedWatchlists: Starting for user:', userUid);
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('watchlistLikes')
                    .where('userUid', '==', userUid)
                    .getDocs();
                console.log('📋 SocialService.getLikedWatchlists: Got', querySnapshot.length, 'watchlistLikes documents');
                const watchlistIds = querySnapshot.map(doc => doc.data().watchlistId);
                console.log('📋 SocialService.getLikedWatchlists: Watchlist IDs to fetch:', watchlistIds);
                // Fetch the actual watchlists using unified service
                const watchlists = [];
                for (const watchlistId of watchlistIds) {
                    try {
                        console.log('📥 SocialService.getLikedWatchlists: Fetching watchlist:', watchlistId);
                        const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                        const exists = watchlistDoc.exists();
                        console.log('📥 SocialService.getLikedWatchlists: Watchlist', watchlistId, 'exists:', exists);
                        if (exists) {
                            const data = watchlistDoc.data();
                            console.log('📥 SocialService.getLikedWatchlists: Watchlist data keys:', Object.keys(data || {}));
                            watchlists.push(Object.assign({ id: watchlistId }, data));
                        }
                    }
                    catch (error) {
                        console.warn('❌ SocialService.getLikedWatchlists: Failed to fetch liked watchlist:', watchlistId, error);
                    }
                }
                console.log('✅ SocialService.getLikedWatchlists: Returning', watchlists.length, 'watchlists');
                return watchlists;
            }), 'getLikedWatchlists');
        });
    }
    /**
     * Get users who liked a watchlist
     */
    getWatchlistLikers(watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('watchlistLikes')
                    .where('watchlistId', '==', watchlistId)
                    .getDocs();
                return querySnapshot.map(doc => doc.data().userUid);
            }), 'getWatchlistLikers');
        });
    }
    // =============== NOTIFICATION SYSTEM ===============
    /**
     * Create a notification
     */
    createNotification(notification) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Don't create notifications for actions on yourself
                if (notification.recipientId === notification.actorId) {
                    return '';
                }
                // Check for duplicate notifications (skip if index error occurs - non-critical)
                try {
                    const shouldSkip = yield this.shouldSkipDuplicateNotification(notification);
                    if (shouldSkip) {
                        console.log('SocialService: Skipping duplicate notification');
                        return '';
                    }
                }
                catch (error) {
                    console.warn('SocialService: Duplicate check failed (non-critical), continuing with notification creation:', error);
                    // Continue with notification creation even if duplicate check fails
                }
                const now = new Date().toISOString();
                const notificationData = omitUndefinedDeep(Object.assign(Object.assign({}, notification), { 
                    // Include both field names for cross-platform compatibility
                    // Legacy/Functions format: userId, timestamp, read
                    // New/Client format: recipientId, createdAt, isRead
                    userId: notification.recipientId, isRead: false, read: false, createdAt: now, timestamp: now, bundleId: this.generateBundleId(notification.type, notification.actorId, notification.entityId) }));
                const docId = yield (0, unifiedFirestoreService_1.unifiedAddDoc)('notifications', notificationData);
                console.log('SocialService: Notification created successfully');
                return docId;
            }), 'createNotification');
        });
    }
    /**
     * Get user notifications
     * @deprecated Use NotificationService.getUserNotifications() instead - this is kept for backward compatibility
     */
    getUserNotifications(userUid, limitCount = 50) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('notifications')
                    .where('recipientId', '==', userUid)
                    .orderBy('createdAt', 'desc')
                    .limit(limitCount)
                    .getDocs();
                return querySnapshot.map(doc => (Object.assign({ id: doc.id }, doc.data())));
            }), 'getUserNotifications');
        });
    }
    /**
     * Mark notification as read
     */
    markNotificationAsRead(notificationId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('notifications', notificationId, {
                    isRead: true,
                    readAt: new Date().toISOString(),
                });
            }), 'markNotificationAsRead');
        });
    }
    /**
     * Mark all notifications as read for a user
     */
    markAllNotificationsAsRead(userUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Query for unread notifications
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('notifications')
                    .where('userId', '==', userUid)
                    .where('read', '==', false)
                    .getDocs();
                // Update each notification
                const now = new Date().toISOString();
                const updates = querySnapshot.map((docData) => (0, unifiedFirestoreService_1.unifiedUpdateDoc)('notifications', docData.id, {
                    read: true,
                    readAt: now,
                }));
                yield Promise.all(updates);
            }), 'markAllNotificationsAsRead');
        });
    }
    /**
     * Get unread notification count
     * @deprecated Use NotificationService.getUnreadCount() instead - this is kept for backward compatibility
     */
    getUnreadNotificationCount(userUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('notifications')
                    .where('userId', '==', userUid)
                    .where('read', '==', false)
                    .getDocs();
                return querySnapshot.length;
            }), 'getUnreadNotificationCount');
        });
    }
    /**
     * Delete a notification
     */
    deleteNotification(notificationId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                yield (0, unifiedFirestoreService_1.unifiedDeleteDoc)('notifications', notificationId);
            }), 'deleteNotification');
        });
    }
    // =============== ACTIVITY CREATION ===============
    /**
     * Add watchlist created activity
     */
    addWatchlistCreatedActivity(userUid, watchlistId, watchlistName, watchlistMovies = [], watchlistDescription, watchlistIsPrivate, hiddenFromCrew = false) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const posters = watchlistMovies
                    .slice(0, 3)
                    .map(m => m.poster || m.Poster || m.poster_path)
                    .filter(Boolean);
                const activity = {
                    uid: userUid,
                    type: 'watchlist_created',
                    watchlistId,
                    isPrivate: false,
                    hiddenFromCrew,
                    metadata: {
                        watchlistName,
                        watchlistDescription: watchlistDescription || undefined,
                        watchlistIsPrivate: watchlistIsPrivate || false,
                        watchlistMovieCount: watchlistMovies.length,
                        watchlistPosters: posters,
                    },
                    createdAt: new Date().toISOString()
                };
                yield (0, unifiedFirestoreService_1.unifiedAddDoc)('userActivity', activity);
                console.log('SocialService: Watchlist created activity added successfully');
            }), 'addWatchlistCreatedActivity');
        });
    }
    /**
     * Update the metadata on an existing watchlist_created activity when the
     * watchlist name or description changes. Does NOT create a new activity.
     */
    updateWatchlistActivity(userUid, watchlistId, watchlistName, watchlistDescription) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const existing = yield (0, unifiedFirestoreService_1.unifiedCollection)('userActivity')
                    .where('uid', '==', userUid)
                    .where('watchlistId', '==', watchlistId)
                    .where('type', '==', 'watchlist_created')
                    .getDocs();
                if (existing.length === 0) {
                    console.log('SocialService: No watchlist_created activity found to update for', watchlistId);
                    return;
                }
                const updates = {
                    'metadata.watchlistName': watchlistName,
                };
                if (watchlistDescription !== undefined) {
                    updates['metadata.watchlistDescription'] = watchlistDescription;
                }
                yield Promise.all(existing.map((doc) => (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userActivity', doc.id, updates)));
                console.log(`SocialService: Updated watchlist_created activity metadata for watchlist ${watchlistId}`);
            }), 'updateWatchlistActivity');
        });
    }
    // =============== SOCIAL STATS CLEANUP ===============
    /**
     * Clean up follower/following counts for all users by recalculating based on actual relationships
     */
    cleanupFollowerCounts() {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                console.log('🧹 SocialService: Starting follower count cleanup for all users');
                // Get all user profiles using unified collection
                const usersSnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userProfiles').getDocs();
                const updatePromises = usersSnapshot.map((userDoc) => __awaiter(this, void 0, void 0, function* () {
                    const userId = userDoc.id;
                    try {
                        // Count actual followers
                        const followersSnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userFollowing')
                            .where('followingUid', '==', userId)
                            .getDocs();
                        const actualFollowersCount = followersSnapshot.length;
                        // Count actual following
                        const followingSnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userFollowing')
                            .where('followerUid', '==', userId)
                            .getDocs();
                        const actualFollowingCount = followingSnapshot.length;
                        // Update user profile with correct counts
                        yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userProfiles', userId, {
                            'stats.followersCount': actualFollowersCount,
                            'stats.followingCount': actualFollowingCount,
                            updatedAt: new Date().toISOString()
                        });
                        console.log(`✅ Updated counts for user ${userId}: ${actualFollowersCount} followers, ${actualFollowingCount} following`);
                    }
                    catch (error) {
                        console.error(`❌ Failed to update counts for user ${userId}:`, error);
                    }
                }));
                yield Promise.all(updatePromises);
                console.log('🎉 SocialService: Follower count cleanup completed');
            }), 'cleanupFollowerCounts');
        });
    }
    // =============== USER SEARCH AND DISCOVERY ===============
    /**
     * Get suggested users for discovery
     * Returns public profiles ordered by follower count (popularity)
     * Excludes the current user
     */
    getSuggestedUsers(currentUserId, limit = 20) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                console.log('🔍 SocialService: Getting suggested users for:', currentUserId);
                // Fetch public users ordered by popularity (follower count)
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userProfiles')
                    .where('privacy.profileVisibility', '==', 'public')
                    .orderBy('stats.followersCount', 'desc')
                    .limit(limit * 2) // Fetch more to ensure enough after filtering
                    .getDocs();
                // Get current user's following list for mutual calculation
                const myFollowing = yield this.getFollowing(currentUserId);
                const myFollowingSet = new Set(myFollowing);
                // Calculate mutual followers for each user
                const usersWithMutuals = yield Promise.all(querySnapshot
                    .map(doc => doc.data())
                    .filter(user => user.uid !== currentUserId)
                    .map((user) => __awaiter(this, void 0, void 0, function* () {
                    const theirFollowing = yield this.getFollowing(user.uid);
                    const mutualCount = theirFollowing.filter(uid => myFollowingSet.has(uid)).length;
                    return Object.assign(Object.assign({}, user), { _mutualCount: mutualCount });
                })));
                // Sort by mutual followers first (Rank 1), then total followers (Rank 2)
                const sortedUsers = usersWithMutuals
                    .sort((a, b) => {
                    var _a, _b;
                    // Rank 1: Mutual followers (descending)
                    const mutualDiff = (b._mutualCount || 0) - (a._mutualCount || 0);
                    if (mutualDiff !== 0)
                        return mutualDiff;
                    // Rank 2: Total followers (descending)
                    return (((_a = b.stats) === null || _a === void 0 ? void 0 : _a.followersCount) || 0) - (((_b = a.stats) === null || _b === void 0 ? void 0 : _b.followersCount) || 0);
                })
                    .slice(0, limit); // Apply final limit after sorting
                // Remove temporary _mutualCount property
                const users = sortedUsers.map((_a) => {
                    var { _mutualCount } = _a, user = __rest(_a, ["_mutualCount"]);
                    return user;
                });
                console.log(`✅ SocialService: Found ${users.length} suggested users (sorted by mutual followers then total followers)`);
                return users;
            }), 'getSuggestedUsers');
        });
    }
    /**
     * Users that both you and `otherUserId` follow (intersection of following lists).
     * Used for “mutual crew” thumbnails on suggested profiles.
     */
    getMutualFollowingPreview(otherUserId, myFollowingIds, avatarLimit = 3) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const theirFollowing = yield this.getFollowing(otherUserId);
                const mine = new Set(myFollowingIds);
                const mutual = theirFollowing.filter(uid => mine.has(uid) && uid !== otherUserId);
                return {
                    count: mutual.length,
                    mutualUserIds: mutual.slice(0, avatarLimit),
                };
            }), 'getMutualFollowingPreview');
        });
    }
    /**
     * Search users (case-insensitive substring match on name, username, email).
     * Firestore has no native case-insensitive or full-text search; prefix queries on
     * displayName/username also fail when casing differs or usernames are stored without "@".
     * We load a bounded set of public profiles (same visibility as discovery) ordered by
     * popularity, then filter client-side — aligned with firebaseService.searchUsers on web.
     */
    searchUsers(searchTerm, limitCount = 10) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const trimmed = (_a = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim()) !== null && _a !== void 0 ? _a : '';
                if (trimmed.length < 2) {
                    return [];
                }
                const searchTermLower = trimmed.toLowerCase();
                const fetchLimit = Math.min(500, Math.max(120, limitCount * 12));
                const runQuery = () => __awaiter(this, void 0, void 0, function* () {
                    try {
                        return yield (0, unifiedFirestoreService_1.unifiedCollection)('userProfiles')
                            .where('privacy.profileVisibility', '==', 'public')
                            .orderBy('stats.followersCount', 'desc')
                            .limit(fetchLimit)
                            .getDocs();
                    }
                    catch (e) {
                        console.warn('SocialService.searchUsers: ordered query failed, retrying without orderBy', e);
                        return (0, unifiedFirestoreService_1.unifiedCollection)('userProfiles')
                            .where('privacy.profileVisibility', '==', 'public')
                            .limit(fetchLimit)
                            .getDocs();
                    }
                });
                const snapshot = yield runQuery();
                const candidates = [];
                snapshot.forEach((docData) => {
                    const profile = docData.data();
                    if (profile === null || profile === void 0 ? void 0 : profile.uid) {
                        candidates.push(profile);
                    }
                });
                const matches = candidates.filter(user => {
                    var _a;
                    if (!user.displayName && !user.email && !user.username)
                        return false;
                    const displayName = (user.displayName || '').toLowerCase();
                    const email = (user.email || '').toLowerCase();
                    const username = (user.username || '').toLowerCase();
                    const emailLocal = (_a = email.split('@')[0]) !== null && _a !== void 0 ? _a : '';
                    return (displayName.includes(searchTermLower) ||
                        email.includes(searchTermLower) ||
                        username.includes(searchTermLower) ||
                        displayName.split(/\s+/).some(word => word.startsWith(searchTermLower)) ||
                        username.startsWith(searchTermLower) ||
                        emailLocal.includes(searchTermLower));
                });
                matches.sort((a, b) => {
                    var _a, _b;
                    const aDisplayName = (a.displayName || '').toLowerCase();
                    const bDisplayName = (b.displayName || '').toLowerCase();
                    const aUsername = (a.username || '').toLowerCase();
                    const bUsername = (b.username || '').toLowerCase();
                    if (aDisplayName === searchTermLower && bDisplayName !== searchTermLower)
                        return -1;
                    if (bDisplayName === searchTermLower && aDisplayName !== searchTermLower)
                        return 1;
                    if (aUsername === searchTermLower && bUsername !== searchTermLower)
                        return -1;
                    if (bUsername === searchTermLower && aUsername !== searchTermLower)
                        return 1;
                    if (aDisplayName.startsWith(searchTermLower) && !bDisplayName.startsWith(searchTermLower))
                        return -1;
                    if (bDisplayName.startsWith(searchTermLower) && !aDisplayName.startsWith(searchTermLower))
                        return 1;
                    const aFollowers = ((_a = a.stats) === null || _a === void 0 ? void 0 : _a.followersCount) || 0;
                    const bFollowers = ((_b = b.stats) === null || _b === void 0 ? void 0 : _b.followersCount) || 0;
                    return bFollowers - aFollowers;
                });
                return matches.slice(0, limitCount);
            }), 'searchUsers');
        });
    }
    // =============== ACTIVITY SYSTEM ===============
    /**
     * Get user activity
     * Uses native Firestore on iOS/Android, web SDK on web
     */
    getUserActivity(uid, limitCount = 20) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                console.log(`🔍 SocialService: Querying userActivity for uid: ${uid}, limit: ${limitCount}`);
                // Use unifiedCollection for cross-platform support (native + web)
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userActivity')
                    .where('uid', '==', uid)
                    .orderBy('createdAt', 'desc')
                    .limit(limitCount)
                    .getDocs();
                const activities = querySnapshot.map(doc => (Object.assign({ id: doc.id }, doc.data())));
                console.log(`✅ SocialService: Found ${activities.length} activities for user ${uid}`);
                return activities;
            }), 'getUserActivity');
        });
    }
    /**
     * Paginated version of getUserActivity — pass afterDate to fetch the next page.
     * Uses a Date cursor on createdAt (works for both Timestamp and ISO string docs).
     */
    getUserActivityPage(uid, pageSize = 50, afterDate) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                let q = (0, unifiedFirestoreService_1.unifiedCollection)('userActivity')
                    .where('uid', '==', uid)
                    .orderBy('createdAt', 'desc');
                if (afterDate) {
                    // createdAt is stored as ISO string — compare with string, not Date object
                    q = q.where('createdAt', '<', afterDate.toISOString());
                }
                q = q.limit(pageSize);
                const snapshot = yield q.getDocs();
                return snapshot.map(doc => (Object.assign({ id: doc.id }, doc.data())));
            }), 'getUserActivityPage');
        });
    }
    /**
     * Paginated following activity — uses a timestamp cursor so it works cleanly
     * across chunks of followed users. Pass afterCreatedAt (ISO string) for next page.
     */
    getFollowingActivityPage(followingUids, pageSize = 100, afterDate) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                if (followingUids.length === 0)
                    return [];
                const chunks = [];
                for (let i = 0; i < followingUids.length; i += FOLLOWING_CHUNK_SIZE) {
                    chunks.push(followingUids.slice(i, i + FOLLOWING_CHUNK_SIZE));
                }
                // Use a higher per-chunk limit so no user gets squeezed out within a chunk
                // Each chunk of 10 users gets up to 50 * 10 = 500 slots before the per-user cap
                const PER_CHUNK_FETCH = Math.min(50 * FOLLOWING_CHUNK_SIZE, 500);
                const results = yield Promise.allSettled(chunks.map(chunk => {
                    let q = (0, unifiedFirestoreService_1.unifiedCollection)('userActivity')
                        .where('uid', 'in', chunk)
                        .orderBy('createdAt', 'desc');
                    if (afterDate)
                        q = q.where('createdAt', '<', afterDate);
                    return q.limit(PER_CHUNK_FETCH).getDocs();
                }));
                const all = [];
                for (const r of results) {
                    if (r.status === 'fulfilled') {
                        for (const doc of r.value)
                            all.push(Object.assign({ id: doc.id }, doc.data()));
                    }
                }
                // Activity type priority: review > rating > watched > added (matches bundleCrewItems scoring)
                const activityPriority = (type) => {
                    if (type === 'movie_reviewed')
                        return 4;
                    if (type === 'movie_rated')
                        return 3;
                    if (type === 'movie_watched' || type === 'marked_as_watched')
                        return 2;
                    if (type === 'watchlist_created' || type === 'created_watchlist')
                        return 2;
                    return 1;
                };
                // Sort: primary by recency, secondary by activity type priority
                all.sort((a, b) => {
                    const ta = typeof a.createdAt === 'string' ? a.createdAt : '';
                    const tb = typeof b.createdAt === 'string' ? b.createdAt : '';
                    const dateDiff = tb.localeCompare(ta);
                    if (dateDiff !== 0)
                        return dateDiff;
                    return activityPriority(b.type) - activityPriority(a.type);
                });
                return all.filter(a => !a.hiddenFromCrew).slice(0, pageSize);
            }), 'getFollowingActivityPage');
        });
    }
    /**
     * Get activity from following users
     */
    getFollowingActivity(followingUids, limitCount = 50) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                if (followingUids.length === 0) {
                    return [];
                }
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userActivity')
                    .where('uid', 'in', followingUids.slice(0, 10)) // Firestore limits 'in' queries to 10 items
                    .orderBy('createdAt', 'desc')
                    .limit(limitCount)
                    .getDocs();
                return querySnapshot
                    .map(doc => (Object.assign({ id: doc.id }, doc.data())))
                    .filter(a => !a.hiddenFromCrew);
            }), 'getFollowingActivity');
        });
    }
    /**
     * Get following-user activity for a specific movie.
     *
     * Queries userActivity where movieId == targetMovieId, then filters client-side
     * to only docs whose uid is in followingUids. Reviews are excluded because they
     * already appear in the reviews carousel on the movie detail page.
     */
    getMovieFollowingActivity(movieId, followingUids) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                if (!movieId || followingUids.length === 0)
                    return [];
                const followingSet = new Set(followingUids);
                const MOVIE_TYPES = new Set([
                    'movie_watched', 'movie_rated',
                    'watchlist_add', 'marked_as_watched', 'movie_added_to_list',
                ]);
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userActivity')
                    .where('movieId', '==', movieId)
                    .orderBy('createdAt', 'desc')
                    .limit(100)
                    .getDocs();
                return querySnapshot
                    .map(doc => (Object.assign({ id: doc.id }, doc.data())))
                    .filter(a => followingSet.has(a.uid) &&
                    !a.isPrivate &&
                    !a.hiddenFromCrew &&
                    MOVIE_TYPES.has(a.type));
            }), 'getMovieFollowingActivity');
        });
    }
    /**
     * Paginated version of getAllPostsActivity — pass afterDocId (last doc ID) for next page.
     */
    getAllPostsActivityPage(pageSize = 100, afterDocId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                let q = (0, unifiedFirestoreService_1.unifiedCollection)('userActivity').orderBy('createdAt', 'desc');
                if (afterDocId)
                    q = q.startAfter(afterDocId);
                q = q.limit(pageSize);
                const snapshot = yield q.getDocs();
                return snapshot
                    .map(doc => (Object.assign({ id: doc.id }, doc.data())))
                    .filter(a => !a.hiddenFromCrew);
            }), 'getAllPostsActivityPage');
        });
    }
    /**
     * Get recent activity across all users (for the global "All posts" feed).
     * Returns raw activities ordered by recency; callers are responsible for
     * filtering by visibility rules (e.g. hide low-signal types from non-followed authors).
     */
    getAllPostsActivity(limitCount = 200) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userActivity')
                    .orderBy('createdAt', 'desc')
                    .limit(limitCount)
                    .getDocs();
                return querySnapshot
                    .map(doc => (Object.assign({ id: doc.id }, doc.data())))
                    .filter(a => !a.hiddenFromCrew);
            }), 'getAllPostsActivity');
        });
    }
    /**
     * Subscribe to user activity (real-time updates)
     */
    subscribeToUserActivity(uid, callback) {
        const activitiesRef = (0, firebaseBase_1.collection)((0, firebaseBase_1.getDb)(), 'userActivity');
        const q = (0, firebaseBase_1.query)(activitiesRef, (0, firebaseBase_1.where)('uid', '==', uid), (0, firebaseBase_1.orderBy)('createdAt', 'desc'), (0, firebaseBase_1.limit)(20));
        return (0, firebaseBase_1.onSnapshot)(q, (querySnapshot) => {
            const activities = querySnapshot.docs.map(doc => (Object.assign({ id: doc.id }, doc.data())));
            callback(activities);
        });
    }
    // =============== HIDE FROM CREW ===============
    /**
     * Hide an activity from the crew feed (only the activity owner can do this)
     */
    hideActivityFromCrew(activityId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Verify the activity belongs to the user
                const activityDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userActivity', activityId);
                if (!activityDoc.exists()) {
                    throw new Error('Activity not found');
                }
                const activityData = activityDoc.data();
                if (activityData.uid !== userId) {
                    throw new Error('You can only hide your own activities');
                }
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userActivity', activityId, {
                    hiddenFromCrew: true,
                });
                console.log(`✅ SocialService: Activity ${activityId} hidden from crew`);
            }), 'hideActivityFromCrew');
        });
    }
    /**
     * Unhide an activity from the crew feed
     */
    unhideActivityFromCrew(activityId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Verify the activity belongs to the user
                const activityDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userActivity', activityId);
                if (!activityDoc.exists()) {
                    throw new Error('Activity not found');
                }
                const activityData = activityDoc.data();
                if (activityData.uid !== userId) {
                    throw new Error('You can only unhide your own activities');
                }
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userActivity', activityId, {
                    hiddenFromCrew: false,
                });
                console.log(`✅ SocialService: Activity ${activityId} unhidden from crew`);
            }), 'unhideActivityFromCrew');
        });
    }
    /**
     * Delete all userActivity records for a specific user+movie combination (e.g. after admin deletes a review).
     */
    deleteActivityByMovieId(userId, movieId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const docs = yield (0, unifiedFirestoreService_1.unifiedCollection)('userActivity')
                    .where('uid', '==', userId)
                    .where('movieId', '==', movieId)
                    .getDocs();
                yield Promise.all(docs.map((d) => (0, unifiedFirestoreService_1.unifiedDeleteDoc)('userActivity', d.id)));
                console.log(`✅ SocialService: Deleted ${docs.length} userActivity records for ${userId}/${movieId}`);
            }), 'deleteActivityByMovieId');
        });
    }
    /**
     * Get user's hidden activities (for the "Hidden from Crew" page)
     */
    getHiddenActivities(userId, limitCount = 50) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                console.log(`🔍 SocialService: Getting hidden activities for user ${userId}`);
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userActivity')
                    .where('uid', '==', userId)
                    .where('hiddenFromCrew', '==', true)
                    .orderBy('createdAt', 'desc')
                    .limit(limitCount)
                    .getDocs();
                const activities = querySnapshot.map(doc => (Object.assign({ id: doc.id }, doc.data())));
                console.log(`✅ SocialService: Found ${activities.length} hidden activities`);
                return activities;
            }), 'getHiddenActivities');
        });
    }
    // =============== PRIVATE HELPER METHODS ===============
    /**
     * Get user profile (internal method)
     */
    getUserProfile(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const userDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', userId);
                return userDoc.exists() ? userDoc.data() : null;
            }), 'getUserProfile');
        });
    }
    /**
     * Filter user profile for privacy
     */
    filterUserProfileForPrivacy(user) {
        const { privacy } = user;
        if (privacy.profileVisibility === 'private') {
            return Object.assign(Object.assign({}, user), { bio: undefined, location: undefined, website: undefined, socialLinks: undefined });
        }
        return user;
    }
    /**
     * Check if we should skip creating a duplicate notification
     */
    shouldSkipDuplicateNotification(notification) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Check for recent duplicate notifications (within last hour)
                const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000).toISOString();
                // Build query using unified collection
                let queryBuilder = (0, unifiedFirestoreService_1.unifiedCollection)('notifications')
                    .where('recipientId', '==', notification.recipientId)
                    .where('type', '==', notification.type)
                    .where('actorId', '==', notification.actorId)
                    .where('createdAt', '>=', oneHourAgo);
                // Add entityId filter if provided
                if (notification.entityId) {
                    queryBuilder = queryBuilder.where('entityId', '==', notification.entityId);
                }
                const querySnapshot = yield queryBuilder.getDocs();
                return querySnapshot.length > 0;
            }), 'shouldSkipDuplicateNotification');
        });
    }
    /**
     * Generate bundle ID for notification grouping
     */
    generateBundleId(type, actorId, entityId) {
        const parts = [type];
        if (actorId)
            parts.push(actorId);
        if (entityId)
            parts.push(entityId);
        return parts.join('_');
    }
}
// Export singleton instance
exports.socialService = new SocialService();
exports.default = exports.socialService;
